module.exports = __webpack_public_path__ + "static/media/cart.035c9f91.svg";